import { render } from "./EditManager.vue?vue&type=template&id=04a6f05a&scoped=true"
import script from "./EditManager.vue?vue&type=script&lang=js"
export * from "./EditManager.vue?vue&type=script&lang=js"

import "./EditManager.vue?vue&type=style&index=0&id=04a6f05a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a6f05a"]])

export default __exports__